import React from 'react';
import Create from '../../rest/Create';
import Form from '../components/Form';

const MistakeRecordsCreate = props => (
  <Create {...props} resource="mistakeRecords">
    <Form />
  </Create>
);

MistakeRecordsCreate.propTypes = {};

export default MistakeRecordsCreate;
